<h2 mat-dialog-title style="text-align: center">Delete Item</h2>
<div style="text-align: center">
    <mat-label style="font-size: small">Are you sure you want to delete this item?</mat-label>
</div>
<mat-dialog-actions style="justify-content: space-between; margin: 10px" class="p-2">
    <button mat-raised-button color="warn" style="width: 100px" (click)="onCancel()" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" style="width: 100px" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
